export default __webpack_public_path__ + "static/media/flower_img_top_schedule.c377d4b7.webp";